export const TermsOfService = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: 29/09/2025</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
        <p>
          By creating an account, signing in, or using{" "}
          <strong>APF Reporting</strong> (the “Service”), you agree to be bound
          by these Terms of Service (the “Terms”). If you do not agree, please
          do not access or use the Service.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          2. Description of Service
        </h2>
        <p>
          <strong>APF Reporting</strong> provides data centralisation and
          intelligent insights. We use third-party integrations, including but
          not limited to:
        </p>
        <ul className="list-disc list-inside mt-2">
          <li>
            Firebase Authentication (for secure login and account management)
          </li>
          <li>Firebase Firestore (for data storage, if applicable)</li>
          <li>Other integrations but do not store any analytical data </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. User Accounts</h2>
        <ul className="list-disc list-inside">
          <li>
            You must create an account via Firebase Authentication to use
            certain features.
          </li>
          <li>
            You agree to provide accurate and complete registration information.
          </li>
          <li>
            You are responsible for maintaining the confidentiality of your
            login credentials.
          </li>
          <li>
            We may suspend or terminate accounts that violate these Terms.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul className="list-disc list-inside mt-2">
          <li>Use the Service for unlawful or harmful activities.</li>
          <li>
            Attempt to access, tamper with, or use non-public areas of the
            Service.
          </li>
          <li>
            Misuse integrations, APIs, or data provided by third-party services.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          5. Third-Party Integrations
        </h2>
        <p>
          Our Service relies on third-party services such as Firebase. By using
          the Service, you also agree to the terms and privacy practices of
          those providers, including:
        </p>
        <ul className="list-disc list-inside mt-2">
          <li>
            <a
              href="https://firebase.google.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              Firebase Terms of Service
            </a>
          </li>
          <li>
            <a
              href="https://stripe.com/legal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              Stripe Terms
            </a>{" "}
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Data & Privacy</h2>
        <p>
          We store account and usage data securely using Firebase and related
          integrations. Your data may be processed and stored outside your
          country of residence. For details, please see our{" "}
          <strong>Privacy Policy</strong>.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          7. Modifications to the Service
        </h2>
        <p>
          We may update, change, or discontinue features of the Service at any
          time without liability.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Termination</h2>
        <p>
          We may suspend or terminate your access if you breach these Terms,
          misuse the Service, or engage in fraudulent or illegal activity.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          9. Disclaimer of Warranties
        </h2>
        <p>
          The Service is provided “as is” without warranties of any kind. We do
          not guarantee uninterrupted or error-free service.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          10. Limitation of Liability
        </h2>
        <p>
          To the maximum extent permitted by law, <strong>APF Reporting</strong>{" "}
          and its affiliates shall not be liable for any damages arising from
          your use of the Service.
        </p>
      </section>

      <footer className="mt-10 text-sm text-gray-500">
        If you have questions about these Terms, please contact us at
        <a
          href="mailto:support@yourapp.com"
          className="text-blue-600 underline ml-1"
        >
          hello@apfome.com
        </a>
        .
      </footer>
    </div>
  );
};
